import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import UserFieldsForm from "./user-fields-form/index";
import GetUserButton from "./GetUserButton";
import OptionCriteriaRadioButton from "./OptionCriteriaRadioButton";
import ET3Div from "../../../../core/et3-div";

const SearchForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1500}
      height={155}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <OptionCriteriaRadioButton />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <UserFieldsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <GetUserButton />
    </ET3Div>
  );
});
export default SearchForm;
